import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { createSelector } from 'reselect'
import { BookmarkDatesAndOccupancy } from 'tripPlanner/types/tripItem'

const memoizeOccupancy = createSelector(
  (offerPageState: OfferPageState) => offerPageState.rooms,
  (rooms?: App.RoomOccupants[]) => rooms?.map(room => ({
    adults: room.adults,
    children: room.children,
    infants: room.infants,
    childrenAge: room.childrenAge,
  })),
)

export const getDatesAndGuestsFromOfferPageState = (offerPageState: OfferPageState): BookmarkDatesAndOccupancy => {
  /*
   * Note: For LE offer pages, the end date is derived from `checkInDate` plus `duration`.
   * Whereas for bedbank offer page, `checkOutDate` is used explicitly and there's no `duration`.
   */
  const checkOutDate =
    ((offerPageState.checkInDate && offerPageState.duration) ?
      offerPageState.checkInDate.clone().add(offerPageState.duration, 'days') :
      offerPageState.checkOutDate
    )

  return {
    checkInDate: offerPageState.checkInDate,
    checkOutDate,
    durationInDays: offerPageState.duration,
    occupancies: memoizeOccupancy(offerPageState),
  }
}
